export default {"src":"/_next/static/media/identify-user-access.78e0241e.svg","height":670,"width":670,"blurWidth":0,"blurHeight":0};